import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { buyShopOffer } from '@patrianna-payments/shared-store/payments/store/middleware-actions'
import type { OfferInfo } from '@patrianna-payments/shared-store/payments/types/openApiModels/OfferInfo'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import BannerTile from 'components/BannerTile'
import { trackSPPlacementDisplayed, trackSPPlacementInteracted } from 'src/analyticActions/common/trackPaymentSnowplow'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'
import { getBannerOffersSelector } from 'store/modules/shop/selectors'

export default function FirstTimeSCOffers() {
  const router = useRouter()
  const offers = useAppSelector(getBannerOffersSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (offers.length > 0) {
      trackSPPlacementDisplayed({
        paymentFlow: 'home_banner',
        placementName: 'banner',
        paymentProduct: 'multiple',
      })
    }
  }, [offers.length])

  const openFirstSweep = (offer: OfferInfo, category: string) => {
    nextTick().then(() => {
      trackEvent('clicked_on_banner', { category })
      trackSPPlacementInteracted({
        paymentFlow: 'home_banner',
        placementName: 'banner',
        offer,
        placementTrigger: 'click_banner',
      })
      dispatch(buyShopOffer({ offer, routerPush: router.push, snowplowPayFlow: 'offer_popup' }))
    })
  }

  if (!offers.length) {
    return null
  }

  return (
    <>
      {offers.map((i) => {
        const { bannerImageUrl } = i
        const bannerUrl = generateImageUrl(bannerImageUrl, ImagesDirectory.BANNERS)

        return (
          <BannerTile
            onClick={() => openFirstSweep(i, `first-time-sc-offer-banner_${i.code}`)}
            src={bannerUrl}
            alt='shop banner'
            key={i.code}
            dataTest={`first-time-sc-offer-banner_${i.code}`}
          />
        )
      })}
    </>
  )
}
